import { render } from "./DayManagement.vue?vue&type=template&id=25f2a092"
import script from "./DayManagement.vue?vue&type=script&lang=js"
export * from "./DayManagement.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__